var render = function render(){var _vm=this,_c=_vm._self._c;return _c('coupon-popup',{attrs:{"dataSource":_vm.configData,"show":_vm.show,"showName":false},on:{"close":_vm.closePopup},scopedSlots:_vm._u([{key:"footDesc",fn:function(){return [_c('p',{staticClass:"foot-desc",on:{"click":_vm.jumpCoupon}},[_vm._v("\n      "+_vm._s(_vm.$t('luckyDraw.award_desc.deposit'))+"\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }